import {Component, OnDestroy, OnInit} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {Router, RouterLink} from "@angular/router";
import {AuthService} from "../../../auth/auth.service";
import {NavbarComponent} from "../navbar.component";
import {NgClass, NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'top-bar',
  templateUrl: './top-bar.component.html',
  standalone: true,
  imports: [
    NgClass,
    NgOptimizedImage,
    RouterLink
  ],
  styles: 'a { text-decoration: none; }'
})
export class TopBarComponent implements OnInit {

  items?: MenuItem[];
  adminConsoleDate: Date = new Date()

  constructor(
    public app: NavbarComponent,
    private router: Router,
    public authService: AuthService
  ) {
  }

  ngOnInit() {
    setInterval(() => {
      this.adminConsoleDate = new Date();
    }, 1000);
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['login']);
  }
}
